export default {
    user: {
        name: 'John Doe',
        email: 'jdoe@mcdonalds.com'
    },
    channels: {
        channelNames: ['TV', 'Instagram', 'Facebook', 'OOH'],
        channelColors: ['#c23531', '#2f4554', '#61a0a8', '#d48265'],
        channelLogos: ['tv.png', 'instagram.png', 'facebook.png', 'ooh.png'],
    },
    salesCategories: {
        categoryNames: ['Main', 'Dessert', 'Breakfast'],
        categoryLogos: ['', '', '']
    },
    attribution: {
        links: [{
            source: 'TV',
            target: 'Main',
            value: 234560
        }, {
            source: 'TV',
            target: 'Dessert',
            value: 121210
        }, {
            source: 'TV',
            target: 'Breakfast',
            value: 121210
        }, {
            source: 'Instagram',
            target: 'Main',
            value: 234560
        }, {
            source: 'Instagram',
            target: 'Dessert',
            value: 121210
        }, {
            source: 'Instagram',
            target: 'Breakfast',
            value: 121210
        }, {
            source: 'Facebook',
            target: 'Main',
            value: 232320
        }, {
            source: 'Facebook',
            target: 'Dessert',
            value: 123450
        },  {
            source: 'Facebook',
            target: 'Breakfast',
            value: 123450
        }, {
            source: 'OOH',
            target: 'Main',
            value: 232320
        }, {
            source: 'OOH',
            target: 'Dessert',
            value: 123450
        },  {
            source: 'OOH',
            target: 'Breakfast',
            value: 123450
        }, {
            source: 'Economy',
            target: 'Main',
            value: 135240
        }, {
            source: 'Economy',
            target: 'Dessert',
            value: 112210
        }, {
            source: 'Economy',
            target: 'Breakfast',
            value: 112210
        },  {
            source: 'Base',
            target: 'Main',
            value: 543210
        }, {
            source: 'Base',
            target: 'Dessert',
            value: 323230
        }, {
            source: 'Base',
            target: 'Breakfast',
            value: 323230
        }, {
            source: 'Competition',
            target: 'Main',
            value: 124530
        }, {
            source: 'Competition',
            target: 'Dessert',
            value: 131320
        }, {
            source: 'Competition',
            target: 'Breakfast',
            value: 131320
        }],

    },
    recommendation: {
        periods: {
            shortNames: ['Jan','Feb','Mar','Apr','May','Jun','Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            longNames: ['January','February','March','April','May','June','July', 'August', 'September', 'October', 'November', 'December']
        },
        channelProposedMix: [
            [10, 15, 20, 40, 20, 20, 10, 20, 40, 20, 20, 10],
            [20, 15, 25, 10, 10, 60, 10, 25, 10, 10, 60, 10],
            [30, 35, 5, 20,	20,	10,	10,	5, 20, 20, 10, 10],
            [40, 35, 50, 30, 50, 10, 70, 50, 30, 50, 10, 70]
        ],
        channelReferenceMix: [
            [40, 35, 50, 30, 50, 10, 70, 50, 30, 50, 10, 70],
            [30, 35, 5, 20,	20,	10,	10,	5, 20, 20, 10, 10],
            [20, 15, 25, 10, 10, 60, 10, 25, 10, 10, 60, 10],
            [10, 15, 20, 40, 20, 20, 10, 20, 40, 20, 20, 10]
        ]
    },
    gain: {

    }
}